<span class="badge badge-cliente-analise-mercado-status-projetado-badge badge-cliente-analise-mercado-status-projetado-badge-projetado"
    [title]="getTitle()">
    {{status.nome}}    
</span>